module.exports = __webpack_public_path__ + "assets_1789888786567/img/pic.cd38b695.png";